module.exports = __webpack_public_path__ + "img/relateds-banner.f146563a.jpg";